<div class="main-content">
  <app-message></app-message>
  <app-sidebar></app-sidebar>
  <div class="content">
    <app-header></app-header>

    <div class="inner" [ngClass]="{'sub': subActive}">
    
        <app-submenu></app-submenu>
        <div style="padding-top: 15px;">
        <div class="container-fluid">
          <div class="row">
            <div class="col-xs-12">
              <router-outlet></router-outlet>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>